import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import { Download } from "lucide-react";
import * as XLSX from "xlsx";
import { useTheme } from "../style/theme";

const ExportModal = ({ open, handleClose, tableData }) => {
    const [format, setFormat] = useState("xls");
    const { mode } = useTheme();

    const handleExport = () => {
        const ws = XLSX.utils.json_to_sheet(tableData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");

        let fileExtension = format === "xlsx" ? ".xlsx" : format === "csv" ? ".csv" : format === "tsv" ? ".tsv" : ".xls";
        const fileType = format === "csv" ? "csv" : format === "tsv" ? "tsv" : "xlsx";

        if (fileType === "csv") {
            XLSX.writeFile(wb, `export${fileExtension}`, { bookType: "csv" });
        } else if (fileType === "tsv") {
            XLSX.writeFile(wb, `export${fileExtension}`, { bookType: "csv", FS: "\t" });
        } else {
            XLSX.writeFile(wb, `export${fileExtension}`, { bookType: format });
        }

        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <div className={`${mode == 'light' ? "bg-white" : 'bg-[#141414]'}`}>
                <DialogTitle>Export</DialogTitle>
                <div className="px-5 pb-5">
                    <div className={`${mode == 'light' ? "bg-white border border-[#d7e2ed]" : 'bg-[#171717]'} rounded-lg p-2`}>
                        <DialogContent className="flex flex-col items-center">
                            <div className="my-3">
                                <img
                                    src="/images/chatStep1.png" // Replace with your image if needed
                                    alt="Export"
                                    className="w-32 h-32 object-contain"
                                />
                            </div>
                            <div className="text-center font-semibold text-base">Choose file format</div>
                            <RadioGroup
                                row
                                value={format}
                                onChange={(e) => setFormat(e.target.value)}
                                className="mt-2"
                            >
                                <FormControlLabel value="xls" control={<Radio />} label="XLS" />
                                <FormControlLabel value="xlsx" control={<Radio />} label="XLSX" />
                                <FormControlLabel value="csv" control={<Radio />} label="CSV" />
                                <FormControlLabel value="tsv" control={<Radio />} label="TSV" />
                            </RadioGroup>
                        </DialogContent>
                    </div>
                    <div className='flex items-center mt-3 gap-3' >
                        <button className="bg-[#0088FF] text-white rounded-[4px] px-3 py-1 text-sm" onClick={handleExport} variant="contained">Export</button>
                        <button className="border border-[#0088FF] text-[#0088FF] rounded-[4px] px-3 py-1 text-sm" onClick={handleClose} variant="outlined">Cancel</button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ExportModal;
